<template>
  <div id="rootContainer">
    <div class="css_container" id="css_container" v-if="legends.length>0"
         style="max-height: 500px; overflow-y: scroll;">
      <el-col>
        <el-row style="text-align: left;margin-bottom: 5px;font-weight: bold;font-size: 14px;">
          <div>{{title}}</div>
        </el-row>
        <el-row v-for="item in legends" v-show="item.label=='mv'?false:true">
          <el-col :span="24" class="cell_col_0" style="display: flex;flex-direction: row; background-color: transparent; overflow: hidden;">
            <div class="cell_tile"  :style="{backgroundColor:item.color}"></div>
           <sapan style="margin-left: 10px;"> {{item.label}}</sapan>
          </el-col>
        </el-row>
      </el-col>
    </div>
  </div>
</template>

<script>

let legend_shousuo =  require( '../../../assets/icons/icon_shousuo.png');
export default {
  name: "CropsRisMapLengend",
  props:{
    title:{
      type:String,
      required: false,
      default:function (){
        return "图例";
      }
    },
    legends:{
      type: Array,
      required:false,
      default:function () {
        return [
          {color:"#1966e6", label:"> 1950"},
          {color:"#1980e5", label:"600 - 950"},
          {color:"#1a99e6", label:"450 - 600"},
          {color:"#40bff2", label:"350 - 45"},
          {color:"#80e6ff", label:"270 - 350"},
          {color:"#99e7fe", label:"250 - 270"},
          {color:"#b3f3ff", label:"150 - 250"},
          {color:"#ccf2ff", label:"50 - 150"},
          {color:"#ffe6b3", label:"20 - 50"},
          {color:"#ffe667", label:"<20"},
          {color:"#e1e1e1", label:"No Data"},
        ];
      }
    }
  },
  data(){
    return {
      layout_model:0,
      color1: '#409EFF',
      icon_legend_shousuo:legend_shousuo
    }
  },mounted() {
    this.updateHeight();
  },
  methods:{

    updateHeight_cropsRisk(){
      console.log("updateHeight && this.legends = ",this.legends);
      if(this.legends!=null && this.legends.length>0){
        let title_height = 30;
        let legend_height = this.legends.length * 25 +title_height;
        document.getElementById("css_container").style.height  = legend_height + "px";
      }
    },

    updateHeight(){
      console.log("updateHeight && this.legends = ",this.legends);
      if(this.legends!=null && this.legends.length>0){
        let title_height = 30;
        let legend_height = this.legends.length * 25 +title_height;
        document.getElementById("css_container").style.height  = legend_height + "px";
      }
    },
    layout_update(){
      let obj = document.getElementById("css_container");
      let obj_height = obj.style.height;
      obj_height = obj_height.substr(0,obj_height.indexOf("px") );
      this.$emit("layoutupdate",obj_height);

      if (this.layout_model==0){
        this.layout_model==1;
      }
    },

    activeChange(event){
      console.log("colos picker = ",this.legends);
      this.$emit("colorsChanged",this.legends);
    }
  }

}
</script>

<style scoped>

::-webkit-scrollbar {display:none}

.css_container{
  background-color:white;
  width: 150px;
  min-height: 125px;
  padding: 10px;
  border: solid 1px lightgrey;
  border-radius: 5px;
}

.css_title{
  background-color: transparent;
  text-align: left;
  font-size: 17px;
  margin-bottom: 10px;
}

.cell_tile{
  width: 50px;
  height: 18px;
  margin-top: 3px;
  margin-right: 5px;
  border: 1px solid lightgrey;
  border-radius: 3px;
}
.cell_col_0
{
  text-align: left;
  font-size: 14px;
  height: 25px;
  line-height: 25px;
}
.cell_col_1
{
  text-align: right;
  font-size: 14px;
  height: 25px;
  line-height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/view/BSD/components/CropsRisMapLengend.vue